import { useLocalStorage, useLocalStorageWithParsing } from "./Context/LocalStorageContext";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

export  const useResetDemo= () => {
    const [sessionId, setSessionId] = useLocalStorage("sessionId");
    const [_, setSteps] = useLocalStorageWithParsing("steps", 0)
    const navigate= useNavigate();

    return () => {
        let apiPrefix = process.env.REACT_APP_ARKG_API_URL;
    fetch(`${apiPrefix}/restart_session`,{
        method: "POST",
        headers: new Headers({
            "Content-Type": "application/json",
        }),
        body: JSON.stringify({
            wallet_id: sessionId,
            issuer_id: "",
        })
    })
        .then(res => res.json())
        .then(json => {
            setSteps(0);
            navigate("/idt/v2/");
        })
        .catch(err => {
            console.log(err);
            navigate("/idt/v2/error",{state:{"error": err}});
        });
    }
    
}